import loginReducer from "./auth/loginReducer"

import {combineReducers} from "redux";

export default combineReducers({
    loginReducer,
})
